<template>
  <div class="triplea-resetpassword-wrapper">
    <div class="triplea-login-form-wrapper">
      <template v-if="!passwordResetSuccessful">
        <p>Please enter your registered email address</p>
        <vs-input
          name="email"
          icon="icon icon-user"
          icon-pack="feather"
          label-placeholder="Email"
          v-model="email"
          class="w-full no-icon-border mb-2"
          :danger="validationEmailError"
          danger-text="Please insert a valid email address" />
        <p v-if="resetPasswordError" style="color: red">
          <small>Reset Password Error. Please insert a valid email and try
            again.</small>
        </p>
        <vs-row class="button-container">
          <vs-button type="border" @click="backToLogin()" class="mr-4"> Back </vs-button>
          <vs-button @click="reset()" :disabled="disabledResetBtn">Reset</vs-button>
        </vs-row>
      </template>
      <template v-else>
        <p>
          Password has been sent to your email. If your email is correct, you
          should receive the new password soon.
        </p>
        <vs-button class="mt-6" type="border" @click="backToLogin()">
          Back to Login
        </vs-button>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResetPassword',
  props: {},
  data() {
    return {
      debugConsole: false,
      email: '',
      passwordResetSuccessful: false,
      validationEmailError: false,

      resetPasswordError: false,
    };
  },

  computed: {
    disabledResetBtn() {
      if (!this.email || (this.email && this.email.indexOf('@') < 2)) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() { },
  methods: {
    backToLogin() {
      this.$store.commit('RESET_PASSWORD', false);
      this.passwordResetSuccessful = false;
    },
    reset() {
      this.apiRequestResetPassword(this.email).then((result) => {
        if (this.debugConsole) console.log('Correct Response', result);
        if (this.debugConsole)
          console.log('Incorrect Response', result.response);

        if (result.status === 200) {
          if (this.debugConsole) console.log('Request Successful', result);
          this.passwordResetSuccessful = true;
          this.validationEmailError = false;
          this.resetPasswordError = false;
        } else if (result.response) {
          if (result.response.data.errors) {
            for (let i = 0; i < result.response.data.errors.length; i++) {
              if (
                result.response.data.errors[i].message === 'invalid' &&
                result.response.data.errors[i].path === 'email'
              ) {
                this.validationEmailError = true;
              }
            }
          }

          //error in API call
          if (result.response && result.response.status !== 200) {
            this.resetPasswordError = true;
          }
        } else {
          this.resetPasswordError = true;
        }
      });
    },
  },
};
</script>

<style>
.triplea-resetpassword-wrapper {
  max-width: 100%;
  /* min-height: 260.5px; */
}

.triplea-resetpassword-wrapper .button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
}

/* native class of vs-input with placeholder */
.vs-con-input-label.is-label-placeholder {
  margin-top: 25px;
}

.warningStyle {
  font-size: 12px;
  font-weight: 500;
  color: orange;
}

@media (max-width: 350px) {
  .button-container {
    justify-content: space-around;
  }
}
</style>
